export default __webpack_public_path__ + "static/lb4-eb165d2d3451e8c36a45eda0ee4d5a68.webp";